module.exports = __webpack_public_path__ + "static/img/1.f79b17b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/views/docs/image/1.jpeg
// module id = 676
// module chunks = 1